import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=036f6d96&scoped=true&"
import script from "./ChannelList.vue?vue&type=script&lang=ts&"
export * from "./ChannelList.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelList.vue?vue&type=style&index=0&id=036f6d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f6d96",
  null
  
)

export default component.exports